import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useAtedimento } from "../../../Context/Atendimento";

import ParcelasAbertasCard from "../../../Components/CardsPages/ParcelasAbertas";
import KPICobrancaParcelas from "../../../Components/CardsPages/KPICobrancaParcelas";

import { IAtendimentoDetalhadoCobranca } from "../../../Interfaces/Cobranca/GestaoAtendimento/GestaoAtendimentoInterface";
import {
    IGeralInfo,
    IParcelas,
} from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { ListarParcelasAbertasUAUController } from "../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faTimes,
    faVoicemail,
    faDollarSign,
} from "@fortawesome/free-solid-svg-icons";

import ModalComponent from "../../../Components/Modais";
import SpinnerComponent from "../../../Components/Loding/Spinner";
import ContatoNaoEfetivo from "./ContatoNaoEfetivo";
import TentativaDeContato from "./TentativaDeContato";
import ContatoEfetivo from "./ContatoEfetivo";

import AtendimentoDetalhado from "../../../Components/CardsPages/Atendimento/AtendimentoDetalhado";
import {
    AtendimentoPageProvider,
    useAtendimentoPage,
} from "../../../Context/AtendimentoPage";
import DadosFinanceiros from "../../../Components/CardsPages/DadosFinanceiros";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useUserInfor } from "../../../Context/User";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { GetCosoCobrancaFatoController } from "../../../Controllers/Cobranca/CasoCobrancaFato/CasoCobrancaFatoControllers";
import {
    ListarProdutosPorContaCompleto,
    VerificaProdutoAdimplenteController,
} from "../../../Controllers/Cobranca/ContaProduto/ContaProdutoController";
import { ACESSOS } from "../../../Routes/Acessos";
import { formatMoneyReais } from "../../../Tools/FormatTools";

interface IAtendimentoPageProps {
    IDCaso: number;
}
interface ITab {
    key: string;
    name: string;
    Component: React.FC<{}>;
    icon: IconProp;
}

export default function Atendimento() {
    const { IDCaso } = useParams<{ IDCaso: string }>();

    return (
        <AtendimentoPageProvider ID_CASO={parseInt(IDCaso)}>
            <AtendimentoPage IDCaso={parseInt(IDCaso)} />
        </AtendimentoPageProvider>
    );
}

function AtendimentoPage(props: IAtendimentoPageProps) {
    const { IDCaso } = props;
    const { FL_MODO_ATENDIMENTO } = useAtedimento();
    const AtendimentoPage = useAtendimentoPage();
    const Atendimento =
        AtendimentoPage.Atendimento as IAtendimentoDetalhadoCobranca;
    const QtdOutrosProdutosInadimplentes =
        AtendimentoPage.QtdOutrosProdutosInadimplentes;

    const { OrgInfor, Config } = useUserInfor();

    const [ParcelaReq, setParcelaReq] = useState<IParcelas>();
    const [geralInfo, setGeralInfo] = useState<IGeralInfo>({} as IGeralInfo);

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [extraTabs, setExtraTabs] = useState<Array<ITab>>([]);
    const [inicialTab, setInicialTab] = useState<ITab>();

    const [statuses, setStatuses] = useState<(boolean | null)[]>([]);

    const { value: casoCobranca } = useAsyncEffect(async () => {
        if (Atendimento.ID_CHAVE_ERP_VENDA) {
            return GetCosoCobrancaFatoController(
                Atendimento.ID_CHAVE_ERP_VENDA
            );
        }
    }, [Atendimento.ID_CHAVE_ERP_VENDA]);

    const [totalInadimplencia, setTotalInadimplencia] = useState({
        parcelasEmAberto: 0,
        valorEmAberto: 0,
    });

    const { value: lstProdutos } = useAsyncEffect(() =>
        ListarProdutosPorContaCompleto(
            Atendimento.ID_CONTA,
            ACESSOS.COBRANCA.ID_MODULO
        )
    );

    const NumeroTotalParcelas = useCallback(() => {
        let total = { parcelasEmAberto: 0, valorEmAberto: 0 };
        lstProdutos?.map((produto, index) => {
            const adimplenciaValue = statuses[index];

            if (produto.UNIDADE || adimplenciaValue) {
                total.valorEmAberto +=
                    produto.UNIDADE.VL_PARCELAS_EM_ABERTO ?? 0;
                total.parcelasEmAberto +=
                    produto.UNIDADE.NR_PARCELAS_ABERTAS ?? 0;
                return setTotalInadimplencia!(total);
            } else {
                return setTotalInadimplencia!({
                    parcelasEmAberto: 0,
                    valorEmAberto: 0,
                });
            }
        });
    }, [lstProdutos, statuses]);

    useEffect(() => {
        NumeroTotalParcelas();
        if (Atendimento?.ID_EMPRESA !== undefined) {
            const parcRequest = {
                NR_EMPRESA: Atendimento.ID_EMPRESA,
                DS_OBRA: Atendimento.DS_OBRA,
                NR_VENDA: Atendimento.NR_VENDA,
            };

            setParcelaReq({
                NR_EMPRESA: Atendimento.ID_EMPRESA,
                DS_OBRA: Atendimento.DS_OBRA,
                NR_VENDA: Atendimento.NR_VENDA,
            });

            const extraTabs = [
                {
                    key: "#financeiro",
                    name: "Dados Financeiros",
                    icon: faDollarSign,
                    Component: () => (
                        <div className="card card-custom">
                            <DadosFinanceiros
                                ID_CHAVE_ERP={`${Atendimento.ID_EMPRESA}_${Atendimento.DS_OBRA}_${Atendimento.NR_VENDA}`}
                            />
                        </div>
                    ),
                },
            ];

            setExtraTabs(extraTabs);
            ListarParcelasAbertasUAUController(parcRequest).then((response) => {
                setGeralInfo({
                    VL_ABERTO: response.reduce(
                        (sum, parcela) => sum + parcela.VL_PARCELA_REAJUSTADO,
                        0.0
                    ),
                    VL_MULTA: response.reduce(
                        (sum, parcela) => sum + parcela.VL_MULTA_ATRASO,
                        0.0
                    ),
                    VL_JUROS: response.reduce(
                        (sum, parcela) => sum + parcela.VL_JUROS_ATRASO,
                        0.0
                    ),
                    QTD_ABERTO: response.length,
                });
                setInicialTab({
                    key: "#parcelasAbertas",
                    name: "Parcelas em Aberto",
                    icon: faDollarSign,
                    Component: () => (
                        <ParcelasAbertasCard ListParcelas={response} />
                    ),
                });
            });
        }
    }, [
        IDCaso,
        Atendimento.ID_EMPRESA,
        Atendimento.DS_OBRA,
        Atendimento.NR_VENDA,
        Atendimento.ID_CASO,
        AtendimentoPage.bloquearInteracoes,
        OrgInfor.COD_ERP_INTEGRACAO,
        Config.ConfigCobrancaDTO?.FL_COB_PERMITE_INSERIR_LANCAMENTO_CUSTA,
        NumeroTotalParcelas,
    ]);
    const boletoReq = useMemo(() => {
        return {
            NR_EMPRESA: Atendimento.ID_EMPRESA,
            DS_OBRA: Atendimento.DS_OBRA,
            NR_VENDA: Atendimento.NR_VENDA,
        } as IParcelas;
    }, [Atendimento]);

    useEffect(() => {
        const fetchData = async () => {
            if (lstProdutos && lstProdutos.length > 0) {
                try {
                    const statusesArray = await Promise.all(
                        lstProdutos?.map(async (produto) => {
                            try {
                                if (produto.UNIDADE.ID_CHAVE_ERP_VENDA) {
                                    const res =
                                        await VerificaProdutoAdimplenteController(
                                            produto.UNIDADE.ID_CHAVE_ERP_VENDA
                                        );
                                    return res;
                                } else {
                                    return null;
                                }
                            } catch (error) {
                                return null;
                            }
                        }) || []
                    );

                    setStatuses(statusesArray);
                } finally {
                }
            }
        };

        fetchData();
    }, [lstProdutos]);

    return (
        <>
            {Atendimento && ParcelaReq ? (
                <div className="row no-gutters w-100">
                    {(FL_MODO_ATENDIMENTO || !Atendimento.DT_FIM) && (
                        <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-4">
                            <li
                                className="nav-item my-1"
                                id="kt_demo_panel_toggle"
                                data-toggle="tooltip"
                                title="Contato Efetivo"
                                data-placement="right"
                                data-original-title="Contato Efetivo"
                            >
                                <button
                                    className="btn btn-sm btn-icon btn-bg-light btn-icon-success btn-hover-success"
                                    onClick={() => {
                                        if (ParcelaReq) {
                                            setModal({
                                                Component: () => (
                                                    <ContatoEfetivo
                                                        setShow={setShow}
                                                        parcelasReq={ParcelaReq}
                                                        ID_CASO={
                                                            Atendimento.ID_CASO
                                                        }
                                                    />
                                                ),
                                                headerComponent:
                                                    "Contato Efetivo",
                                                IconHeader: faCheck,
                                                size: "lg",
                                                scrollable: true,
                                            });
                                            setShow(true);
                                        }
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCheck} />
                                </button>
                            </li>
                            <li
                                className="nav-item my-1"
                                id="kt_demo_panel_toggle"
                                data-toggle="tooltip"
                                title="Tentativa de Contato"
                                data-placement="right"
                                data-original-title="Tentativa de Contato"
                            >
                                <button
                                    className="btn btn-sm btn-icon btn-bg-light btn-icon-warning btn-hover-warning"
                                    onClick={() => {
                                        setModal({
                                            Component: () => (
                                                <TentativaDeContato
                                                    setShow={setShow}
                                                    ID_CASO={
                                                        Atendimento.ID_CASO
                                                    }
                                                />
                                            ),
                                            headerComponent:
                                                "Tentativa de Contato",
                                            IconHeader: faVoicemail,
                                        });
                                        setShow(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faVoicemail} />
                                </button>
                            </li>
                            <li
                                className="nav-item my-1"
                                id="kt_demo_panel_toggle"
                                data-toggle="tooltip"
                                title="Contato não Efetivo"
                                data-placement="right"
                                data-original-title="Contato não Efetivo"
                            >
                                <button
                                    className="btn btn-sm btn-icon btn-bg-light btn-icon-danger btn-hover-danger"
                                    onClick={() => {
                                        setModal({
                                            Component: () =>
                                                ContatoNaoEfetivo(
                                                    { setShow },
                                                    Atendimento.ID_CASO
                                                ),
                                            headerComponent:
                                                "Contato Não Efetivo",
                                            IconHeader: faTimes,
                                        });
                                        setShow(true);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </button>
                            </li>
                        </ul>
                    )}

                    <AtendimentoDetalhado
                        dadosERP={boletoReq}
                        TIPO_CASO="Cobranca"
                        Atendimento={Atendimento}
                        IDCaso={IDCaso}
                        KPICard={() => (
                            <KPICobrancaParcelas
                                KPI={geralInfo}
                                DS_CATEGORIA_ATENDIMENTO={
                                    Atendimento.DS_CATEGORIA_ATENDIMENTO
                                }
                                LST_STATUS_COBRANCA={
                                    Atendimento.LST_STATUS_COBRANCA
                                }
                                LST_STATUS_ESCRITURA={
                                    Atendimento.LST_STATUS_ESCRITURA
                                }
                            />
                        )}
                        extraTabs={extraTabs}
                        inicialTab={inicialTab}
                        alerts={[
                            {
                                show: !!QtdOutrosProdutosInadimplentes,
                                text: `Esse cliente tem mais ${QtdOutrosProdutosInadimplentes} venda${
                                    QtdOutrosProdutosInadimplentes > 1
                                        ? "s"
                                        : ""
                                } inadimplente${
                                    QtdOutrosProdutosInadimplentes > 1
                                        ? "s"
                                        : ""
                                }.   O total de parcela${
                                    totalInadimplencia.parcelasEmAberto > 1
                                        ? "s"
                                        : ""
                                } inadimplente${
                                    totalInadimplencia.parcelasEmAberto > 1
                                        ? "s"
                                        : ""
                                } é de ${
                                    totalInadimplencia.parcelasEmAberto
                                } parcela${
                                    totalInadimplencia.parcelasEmAberto > 1
                                        ? "s"
                                        : ""
                                }. O valor total de parcela${
                                    totalInadimplencia.valorEmAberto > 1
                                        ? "s"
                                        : ""
                                } inadimplente${
                                    totalInadimplencia.valorEmAberto > 1
                                        ? "s"
                                        : ""
                                } é ${formatMoneyReais(
                                    totalInadimplencia.valorEmAberto
                                )}`,
                            },
                            {
                                show: Boolean(casoCobranca?.FL_CLIENTE_SPC),
                                text: " Cliente possui parcelas em Negativação SPC / Serasa",
                            },
                        ]}
                    />

                    <ModalComponent
                        show={show}
                        setShow={setShow}
                        ModalComponent={modal}
                    />
                    <a
                        href="/#"
                        id="abrirBase64"
                        target="_blank"
                        className="d-none"
                        download={"download"}
                    >
                        Link oculto
                    </a>
                </div>
            ) : (
                <SpinnerComponent />
            )}
        </>
    );
}
